import { useContext, useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useSpinner } from '@components/SpinnerContext';
import { AppRoute } from '@models/app-route.model';
import React from 'react';
import Page404 from '@pages/NotFoundPage';
import routeService from '@services/route.service';
import { BackendNode } from '@dtos/backend-node.dto';
import { RouteFactory } from '@factories/route.factory';
import WhereWeArePage from '@pages/WhereWeArePage'
import ContactPage from './ContactPages';
import { GlobalContext } from '@utils/GlobalContext.js';
import NoChildPage from './NoChildPage';
import SponsoredPage from './SponsoredPage';
import { LoadingEnum } from '@enums/loading-enum.enum';
import SuggestionPage from './SuggestionPage';

const RouteChildrenGenerator: any = (currentRoutes: AppRoute[], basePath = "") => {

  return (
    currentRoutes.map((route: AppRoute, index: number) => {
      const fullPath = `${basePath}/${route.path}`;
      return route.element && (<>
        <Route key={index} path={fullPath} element={React.createElement(route.element, { route })} />
        {route.children && route.children.length > 0 && RouteChildrenGenerator(route.children, fullPath)}
      </>
      );
    })
  )
}

function RouteManagerPage() {
  const {seeModal, switchOffLoading, setSwitchOffLoading } = useContext(GlobalContext)
  const [dynamicRoutes, setDynamicRoutes] = useState<AppRoute[] | undefined>(undefined);
  const [isPageNotFound, setIsPageNotFound] = useState(false);
  const { showSpinner, hideSpinner } = useSpinner();
  const location = useLocation();

  useEffect(() => {
    async function getRoutes(accomodationIdQrCode: string) {
      try {
        showSpinner();
        const response = await routeService.findRoutesByAccomodationId(accomodationIdQrCode);
        const data = [response?.data]; 
        const appRoutes: AppRoute[] = data.map((node: BackendNode) =>
          RouteFactory.createRoute(node)
        );
        setSwitchOffLoading([...switchOffLoading, LoadingEnum.ROUTE])
        setDynamicRoutes(appRoutes);
        setIsPageNotFound(false);
      }
      catch (error: any) {
        console.error("Errore caricamento rotte ", error.message);
        setIsPageNotFound(true);
      } finally {
        hideSpinner()
      }
    }
    
    const accomodationIdQrCode = location.pathname.split("/")[1];
    if (accomodationIdQrCode) {
      getRoutes(accomodationIdQrCode)
    }else{
      setIsPageNotFound(true)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    
    if (seeModal) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "";
    }
    return () => {
      document.body.style.overflowY = "";
    };
  }, [seeModal]);

  return (

    <div style={{ minHeight: '100vh' }} className='appwrapper position-relative'>
      {isPageNotFound ? (
        <Routes>
          <Route path="*" element={<Page404 />} />
        </Routes>
      ) : (dynamicRoutes && (
        <Routes>
          {RouteChildrenGenerator(dynamicRoutes)}
          <Route key={dynamicRoutes.length} path="*" element={<Page404 />} />
          <Route path={`${location.pathname.split("/")[1]}/WhereWeAre`} element={<WhereWeArePage />} />
          <Route path={`${location.pathname.split("/")[1]}/Contact`} element={<ContactPage/>}/>
          <Route path={`${location.pathname.split("/")[1]}/Sponsored`} element={<SponsoredPage/>}/>
          <Route path={`${location.pathname.split("/")[1]}/Suggestion`} element={<SuggestionPage/>}/>
          <Route path={`${location.pathname.split("/")[1]}/NoChildPage`} element={<NoChildPage/>}/>
        </Routes>
      )
      )}
    </div>

  );
}

export default RouteManagerPage;
